module.exports = __webpack_public_path__ + "img/guide_enseignant-vignette.41f84eba.png";